import type {
    CreateEfakturaAgreementRequest,
    EFakturaAgreementResponse,
    EFakturaCreditor,
    EFakturaCreditorId,
    Epost,
} from '../generated-types';
import { CONTEXT_PATH } from './index';
import { get, patch, post, put } from './request';

export const SERVICE_PATH = 'rest/resource/efakturaagreements';

export function getEFakturaAgreement(): Promise<EFakturaAgreementResponse> {
    return get<EFakturaAgreementResponse>(`${CONTEXT_PATH}/${SERVICE_PATH}`);
}

export function enableEFakturaAgreement(): Promise<unknown> {
    return patch(`${CONTEXT_PATH}/${SERVICE_PATH}/enable`);
}

export function disableEFakturaAgreement(): Promise<unknown> {
    return patch(`${CONTEXT_PATH}/${SERVICE_PATH}/disable`);
}

export function enableEmailNotifications(email: Epost): Promise<unknown> {
    return patch(`${CONTEXT_PATH}/${SERVICE_PATH}/email-notifications/enable`, email);
}

export function disableEmailNotifications(): Promise<unknown> {
    return patch(`${CONTEXT_PATH}/${SERVICE_PATH}/email-notifications/disable`);
}

export async function createEfakturaAgreement(
    efakturaAgreement?: CreateEfakturaAgreementRequest,
): Promise<EFakturaAgreementResponse> {
    return post<EFakturaAgreementResponse>(`${CONTEXT_PATH}/${SERVICE_PATH}`, efakturaAgreement);
}

export function getEFakturaCreditors(): Promise<EFakturaCreditor[]> {
    return get<EFakturaCreditor[]>(`${CONTEXT_PATH}/${SERVICE_PATH}/creditors`);
}

export function blockEFakturaCreditor(creditorId: EFakturaCreditorId): Promise<unknown> {
    return put(`${CONTEXT_PATH}/${SERVICE_PATH}/creditors/${creditorId.value}/block`);
}

export function unblockEFakturaCreditor(creditorId: EFakturaCreditorId): Promise<unknown> {
    return put(`${CONTEXT_PATH}/${SERVICE_PATH}/creditors/${creditorId.value}/unblock`);
}
